import { ConnectUSPSBusinessAccount } from './ConnectUSPSBusinessAccount.component';
import AddDhlxAccount from './DHLx/AddDhlxAccount.component';
import { AddFedExAccount } from './FedEx/AddFedExAccount.component';
import { FedExSelectOption } from './FedEx/FedExSelectOption.component';
import { ManageCarrier } from './ManageCarrier.component';
import AddUpsCarrier from './UPS/AddUpsCarrier.component';
import Util from './Util';

export default {
	ManageCarrier,
	AddUpsCarrier,
	AddFedExAccount,
	AddDhlxAccount,
	ConnectUSPSBusinessAccount,
	FedExSelectOption,
	Util,
};
